import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "obfuscate",
  standalone: true,
})
export class ObfuscatePipe implements PipeTransform {
  /**
   * Obfuscates a given string by replacing all but the last few characters with asterisks.
   *
   * @param {string} str - The string to be obfuscated.
   * @param {number} [visible_digits] - The number of characters to leave visible at the end of the string.
   * @param {number} [padding] - The total length of the resulting obfuscated string, including visible characters and asterisks.
   * @param {number} [char] - The character to use for obfuscation.
   * @returns {string} - The obfuscated string.
   *
   * @example
   * transform('1234561234', 4, 2);
   * // Returns '**1234'
   */
  transform(str: string): string {
    const last_digits = str.slice(-4);
    return `**** **** **** **${last_digits.slice(0, 2)} ${last_digits.slice(2)}`;
  }
}
